import { gql } from 'apollo-boost';

export const updateInvestmentMutation = gql`
  mutation updateInvestmentMutation(
    $id: Int!,
    $status: String,
    $portfolioId: Int!,
    $granteeAccountId: Int,
    $message: String,
    $cashAmount: Float,
    $goodsAmount: Float,
    $volunteerismAmount: Float,
    $servicesAmount: Float,
    $relationshipManagerId: Int,
    $programNameByDonor: String,
    $externalId: String,
    $tagList: String,
    $reportDate1: Date,
    $reportDate2: Date,
    $reportDate3: Date,
    $reportDate4: Date,
    $reportDate5: Date,
    $reportDate6: Date,
    $timelineDays1: Int,
    $timelineDays2: Int,
    $timelineDays3: Int,
    $timelineDays4: Int,
    $timelineDays5: Int,
    $timelineDays6: Int,
    $timelineFrom1: String,
    $timelineFrom2: String,
    $timelineFrom3: String,
    $timelineFrom4: String,
    $timelineFrom5: String,
    $timelineFrom6: String,
    $firstName:String
    $lastName:String
    $email: String
  ) {
    updateInvestment(
      id: $id,
      status: $status,
      portfolioId: $portfolioId,
      granteeAccountId: $granteeAccountId,
      message: $message,
      cashAmount: $cashAmount,
      goodsAmount: $goodsAmount,
      volunteerismAmount: $volunteerismAmount,
      servicesAmount: $servicesAmount,
      relationshipManagerId: $relationshipManagerId,
      programNameByDonor: $programNameByDonor,
      externalId: $externalId,
      tagList: $tagList,
      reportDate1: $reportDate1,
      reportDate2: $reportDate2,
      reportDate3: $reportDate3,
      reportDate4: $reportDate4,
      reportDate5: $reportDate5,
      reportDate6: $reportDate6,
      timelineDays1: $timelineDays1,
      timelineDays2: $timelineDays2,
      timelineDays3: $timelineDays3,
      timelineDays4: $timelineDays4,
      timelineDays5: $timelineDays5,
      timelineDays6: $timelineDays6,
      timelineFrom1: $timelineFrom1,
      timelineFrom2: $timelineFrom2,
      timelineFrom3: $timelineFrom3,
      timelineFrom4: $timelineFrom4,
      timelineFrom5: $timelineFrom5,
      timelineFrom6: $timelineFrom6,
      firstName: $firstName
      lastName:$lastName
      email: $email
    ) {
      success
      id
      error
    }
  }
`;
